import FieldsW2Information from './FieldsW2Information'

export default FieldsW2Information
